if (!customElements.get('awatt-live-demo')) {
    customElements.define('awatt-live-demo', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const dialog = this.querySelector('dialog');
        const frame = this.querySelector('iframe');
        this.querySelector('.awatt-demo-open').addEventListener('click', () => {
          if (!frame.hasAttribute('src')) frame.setAttribute('src', frame.dataset.src);
          dialog.showModal();
        });
        this.querySelector('.awatt-demo-close').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        });
      }
    });
  }
